import React, { useEffect } from "react";
import CommonLayout from "./CommonLayout";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { getOutOrder } from "actions/orderActions";
import { Order } from "types/interfaces";
import { useParams } from "react-router";
import EntryCardUser from "shared/EntryCardUser";

interface IProfile {
  //Saran enakanan pake status kayaknya kayak tokped jadi tiap pemesanan ada variabel status
  path: string;
  title: string;
  exact?: boolean;
  //status: string;
}

const accountDashboard: IProfile[] = [
  {
    path: "/account-entries",
    title: "Semua Pesanan",
    exact: true,
  },
  {
    path: "/account-entries/new",
    title: "Pesanan Baru",
  },
  {
    path: "/account-entries/ready",
    title: "Dalam Proses Toko",
  },
  {
    path: "/account-entries/delivered",
    title: "Dalam Pengiriman",
  },
  {
    path: "/account-entries/finished",
    title: "Pesanan Selesai",
  },
  {
    path: "/account-entries/canceled",
    title: "Dibatalkan",
  },
];

const AccountEntries = () => {
  const dispatch = useDispatch();
  const { orders } = useSelector((state: RootState) => state.outOrder);

  useEffect(() => {
    dispatch(getOutOrder());
  }, []);

  const { path } = useParams<{ path?: string }>();

  return (
    <div>
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <h2 className="text-3xl font-semibold">Daftar Pesanan</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

          <div className="flex space-x-8 md:space-x-14 overflow-x-auto hiddenScrollbar">
            {accountDashboard.map((item) => {
              return (
                <NavLink
                  key={item.path}
                  exact={item.exact}
                  activeClassName="!border-primary-500"
                  to={item.path && item.path}
                  className="block py-5 md:py-8 border-b-2 border-transparent flex-shrink-0"
                >
                  {item.title}
                </NavLink>
              );
            })}
          </div>

          {/*// TODO: Buat grafik untuk jumlah view, */}

          {typeof path == "undefined"
            ? orders &&
              orders.map((order: Order, index: number) => {
                return <EntryCardUser key={index} data={order} />;
              })
            : orders &&
              orders
                .filter((stat: { status: string }) => stat.status === path)
                .map((order: Order, index: number) => {
                  return <EntryCardUser key={index} data={order} />;
                })}
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountEntries;
